import React, { Component } from 'react';
import TagsNewsComponent from '../../components/news/containers/TagsNewsContainer';
import { getAllTagsIfNeeded } from '../../components/news/actions/NewsActions';
import HeaderTags from '../../common/headerTags/HeaderTags';

const headerTags =
{
    title: 'Confira nossa tags de Notícias', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'Escolha as Noitícias pela suas tags',
        keywords: 'tags, cotidiano, economia, mundo, música, politica, saúde, tecnologia',
        'og:title': 'Confira nossa tags de Notícias',
        'og:description': 'Escolha as Noitícias pela suas tags',
        'og:image': '',
    },
};

class Tags extends Component {
    static fetchData(store) {
        return store.dispatch(getAllTagsIfNeeded());
    }

    render() {
        return (
            <div className="pageWrapper">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <TagsNewsComponent />
            </div>
        );
    }
}

export default Tags;
